import { Menu } from '@mui/icons-material';
import React from 'react';
import { isMenuCollapsed } from '../../../apollo/cache';

const NavigationMenuExpand = () => {
  return (
    <a role='button' id='navigationMenuExpandContainer' onClick={() => isMenuCollapsed(false)}>
      <>
        <Menu className='arrows' />
        <br />
        <span>MENU</span>
      </>
    </a>
  );
};

export default NavigationMenuExpand;
